import React from 'react';

interface IProps {}

const CardRow: React.FunctionComponent<IProps> = props => (
  <div className="card-row">{props.children}</div>
);

export default CardRow;
